var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2852 15H42.7148C45.6337 15 48 17.3663 48 20.2852V44.7113C48 47.6302 45.6337 49.9965 42.7148 49.9965H18.2852C15.3663 49.9965 13 47.6302 13 44.7113V20.2852C13 17.3663 15.3663 15 18.2852 15Z",
    fill: "#006699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1986 44.3716V28.4669H18.9122V44.3716H24.1986ZM21.5561 26.2941C23.3995 26.2941 24.547 25.0728 24.547 23.5466C24.5126 21.986 23.3996 20.7986 21.5911 20.7986C19.7828 20.7986 18.6003 21.986 18.6003 23.5466C18.6003 25.0729 19.7475 26.2941 21.5216 26.2941H21.5559H21.5561Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1246 44.3716H32.411V35.4896C32.411 35.0143 32.4453 34.5394 32.5849 34.1996C32.9671 33.2499 33.8369 32.2662 35.2972 32.2662C37.2102 32.2662 37.9754 33.7247 37.9754 35.8628V44.3715H43.2615V35.2519C43.2615 30.3666 40.6535 28.0935 37.1753 28.0935C34.3235 28.0935 33.0714 29.6876 32.3758 30.7733H32.4111V28.4666H27.1247C27.1941 29.959 27.1247 44.3713 27.1247 44.3713L27.1246 44.3716Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.93aa0642ec8d73fc7d269c5cfda26bb2.svg";
export { ForwardRef as ReactComponent };